import {
	Flex,
	Typography,
	TextColors,
	Tag,
	BorderRadius,
	BackgroundColors,
	BorderColors,
	FontFamilies,
} from "@abel-technologies-as/components";
import { StyledLink } from "./style";
import { useTranslation } from "react-i18next";
import { CompanyList } from "../../types";
import dayjs from "dayjs";
import { AvatarWithFallback } from "@/shared/components";

export const companyStatusColors: Record<string, { bgColor: string; borderColor: string; textColor: string }> = {
	Active: {
		bgColor: BackgroundColors.SuccessPrimary,
		borderColor: BorderColors.Success_200,
		textColor: TextColors.Success_500,
	},
	Inactive: {
		bgColor: BackgroundColors.PrimaryAlt,
		borderColor: BorderColors.Secondary,
		textColor: TextColors.Secondary,
	},
	Churned: {
		bgColor: BackgroundColors.WarningPrimary,
		borderColor: BorderColors.Warning,
		textColor: TextColors.Warning,
	},
};

const useRenderColumns = () => {
	const { t } = useTranslation("companies");

	return [
		{
			field: "companyName",
			headerName: t("company"),
			width: 280,
			renderCell: (row: CompanyList) => {
				return (
					<Flex mediaSm="justify-content: flex-end;" justifyContent={"flex-start"} gap={"12px"}>
						<AvatarWithFallback size={24} imageUrl={row.companyLogo} />
						<Flex gap="4px">
							<Typography fontWeight={500} fontSize={"14px"} color={TextColors.Primary} lineHeight={"20px"}>
								<StyledLink to={`/companies/${row.id}`}>{row.companyName}</StyledLink>
							</Typography>
							<Typography
								fontWeight={400}
								fontSize={"14px"}
								fontFamily={FontFamilies.InterRegular}
								color={TextColors.Tertiary}
								lineHeight={"20px"}>
								{row.isParent ? "Parent" : ""}
							</Typography>
						</Flex>
					</Flex>
				);
			},
		},
		{
			field: "activeEmployees",
			headerName: t("active_employees"),
			width: 150,
			renderCell: (row: CompanyList) => {
				return (
					<Typography
						fontFamily={FontFamilies.InterRegular}
						fontWeight={400}
						fontSize={"14px"}
						color={TextColors.Tertiary}
						lineHeight={"20px"}>
						{row.activeEmployees}
					</Typography>
				);
			},
		},
		{
			field: "keyAccountManager",
			headerName: t("key_account_manager"),
			width: 200,
			renderCell: (row: CompanyList) => {
				return (
					<Typography
						fontFamily={FontFamilies.InterRegular}
						fontWeight={400}
						fontSize={"14px"}
						color={TextColors.Tertiary}
						lineHeight={"20px"}>
						{row.keyAccountManager}
					</Typography>
				);
			},
		},
		{
			field: "billing",
			headerName: t("billing"),
			width: 150,
			renderCell: (row: CompanyList) => {
				return (
					<Typography
						fontFamily={FontFamilies.InterRegular}
						fontWeight={400}
						fontSize={"14px"}
						color={TextColors.Tertiary}
						lineHeight={"20px"}>
						{row.payments} kr
					</Typography>
				);
			},
		},
		{
			field: "payments",
			headerName: t("payments"),
			width: 150,

			renderCell: (row: CompanyList) => {
				return (
					<Typography
						fontFamily={FontFamilies.InterRegular}
						fontWeight={400}
						fontSize={"14px"}
						color={TextColors.Tertiary}
						lineHeight={"20px"}>
						{row.payments}
					</Typography>
				);
			},
		},
		{
			field: "createdAt",
			headerName: t("created"),
			width: 150,
			renderCell: (row: CompanyList) => {
				return (
					<Typography
						fontFamily={FontFamilies.InterRegular}
						fontWeight={400}
						fontSize={"14px"}
						color={TextColors.Tertiary}
						lineHeight={"20px"}>
						{dayjs(row.createdAt).format("DD.MM.YYYY")}
					</Typography>
				);
			},
		},
		{
			field: "status",
			headerName: t("status"),
			width: 150,
			renderCell: (row: CompanyList) => (
				<Tag
					borderRadius={`${BorderRadius.FULL}px`}
					padding={"2px 8px"}
					fontSize={"12px"}
					fontWeight={500}
					lineHeight={"18px"}
					text={row.status}
					backgroundColor={companyStatusColors[row.status].bgColor}
					borderColor={companyStatusColors[row.status].borderColor}
					textColor={companyStatusColors[row.status].textColor}></Tag>
			),
		},
	];
};

export { useRenderColumns };
